import { Loading } from '@components/Loading'
import { Container } from '@components/Container'
import { PromotionStatusEnum } from '@interfaces/promotionCode/PromotionStatusEnum'
import { PromotionSaleForm } from '@features/promotionSetting/components/PromotionSaleForm'
import { EditPromotionSalePageProps } from './interface'

export function EditPromotionSalePage({
  isLoading,
  initialValues,
  saleCoinOptions,
  updatePromotionCode,
}: EditPromotionSalePageProps) {
  return (
    <Container>
      {!isLoading ? (
        initialValues ? (
          <PromotionSaleForm
            initialValues={initialValues}
            handleSubmit={updatePromotionCode}
            title='แก้ไขโปรโมชั่นการขาย'
            saleCoinOptions={saleCoinOptions}
            isEdit={
              ![
                PromotionStatusEnum.DRAFT,
                PromotionStatusEnum.REJECTED,
              ].includes(initialValues.status)
            }
          />
        ) : (
          <div className='m-auto'>เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง</div>
        )
      ) : (
        <Loading size={36} className='m-auto' />
      )}
    </Container>
  )
}
